// extracted by mini-css-extract-plugin
export var posts = "index-module--posts--sXJcV";
export var fadein = "index-module--fadein--zm-Cp";